module.exports = __webpack_public_path__ + "Flag-320.1d57b4b860f4a0c8656fdb96331b6033.svg";